import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	role: string;
	names: string;
};

export const ActivityParticipantGroup: FC<Props> = ({ role, names }) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<Stack gap={spacingTokens.xs}>
			<Typography variant="body2">{role}</Typography>
			<Typography variant="body2" color={palette.grey[900]}>
				{names}
			</Typography>
		</Stack>
	);
};
